import styled from 'styled-components';
import { getUrlWithToken } from '../../../../utils/common';

export const Cover = styled.div`
  width: 100%;
  height: 570px;
  background: url(${({ src }) => getUrlWithToken(src)});
  background-position: center center;
  background-size: cover;

  @media ${(props) => props.theme.device.tablet} {
    height: 660px;
  }
`;

export const Overlay = styled.div`
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.67) 15.31%,
    rgba(104, 104, 104, 0) 103.19%
  );
  width: 100%;
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  color: ${(props) => props.theme.colors.white};
  gap: 48px;
  @media ${(props) => props.theme.device.tablet} {
    gap: 0;
    flex-flow: column;
    flex-wrap: unset;
  }

  > div {
    text-align: center;
    height: calc(50% - 24px);
    font-size: 16px;
    @media ${(props) => props.theme.device.tablet} {
      height: unset;
      width: 100%;
      font-size: 14px;
    }

    p {
      font-size: 50px;
      font-weight: 700;
      @media ${(props) => props.theme.device.tablet} {
        font-size: 40px;
        line-height: 60px;
      }
    }

    &:first-child {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: end;
      font-size: 24px;
      @media ${(props) => props.theme.device.tablet} {
        font-size: 18px;
        margin-bottom: 30px;
      }

      p {
        font-size: 80px;
        @media ${(props) => props.theme.device.tablet} {
          font-size: 60px;
          line-height: 91px;
        }
      }
    }
  }
`;

export const Line = styled.div`
  width: 1px;
  max-height: 114px;
  background-color: white;
  align-self: self-start;

  @media ${(props) => props.theme.device.tablet} {
    width: 97px !important;
    height: 1px !important;
    align-self: unset;
    margin: 18px 0;
  }
`;
